import React, { type ReactNode } from "react";

import clsx from "clsx";

import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  value?: string | number;
  align?: "left" | "right";
  icon?: ReactNode;
}

const DefaultCellFormatter = <
  TData extends { adsetName?: string; adName?: string; kind: string },
>(
  props: TableCellProps<TData>,
) => {
  const row = props.cell.row.original;
  const adsetName = row?.adsetName;
  const adName = row?.adName;
  const showSubtext =
    adsetName && adName && adsetName !== "(no name)" && adName !== "(no name)";
  const isNotReferral = row?.kind !== "referer";
  return (
    <div
      className={clsx(
        "font-medium text-xs px-4 py-2.5 h-full bg-inherit text-v2-primary border-r border-v2-tertiary",
        {
          "justify-start": props.align === "left",
          "justify-end": props.align === "right",
        },
      )}
      title={String(props.cell.getValue())}
    >
      <div
        className={clsx("flex items-center gap-3", {
          "h-full": !(showSubtext && props.cell.column.id === "campaignName"),
        })}
      >
        {props.icon}
        <div className="flex gap-1 break-all">
          {showSubtext &&
            isNotReferral &&
            props.cell.column.id === "campaignName" && (
              <span className="font-semibold w-[64px] min-w-[64px]">
                Campaign:{" "}
              </span>
            )}
          {props.value ? props.value : String(props.cell.getValue() || "--")}
        </div>
      </div>
      {showSubtext &&
        isNotReferral &&
        props.cell.column.id === "campaignName" && (
          <div className="text-v2-secondary text-xs mt-1 ml-9 flex flex-col gap-1 break-all">
            <div className="flex gap-1">
              <div className="font-semibold w-[64px] min-w-[64px] text-right">
                Adset:
              </div>
              <div>{adsetName}</div>
            </div>
            <div className="flex gap-1">
              <div className="font-semibold w-[64px] min-w-[64px] text-right">
                Ad:
              </div>
              <div>{adName}</div>
            </div>
          </div>
        )}
    </div>
  );
};

export default DefaultCellFormatter;
